import { SquareUserIcon, BadgePercent, Proportions, Store } from "lucide-react";

export function getMenuList(pathname) {
  return [
    {
      groupLabel: "",
      menus: [
        {
          href: "/",
          label: "Booking List",
          active: pathname === "/",
          icon: SquareUserIcon,
          submenus: [],
        },
        {
          href: "offercode",
          label: "Offer Code",
          active: pathname.includes("/offercode"),
          icon: BadgePercent,
          submenus: [],
        },
        {
          href: "report",
          label: "Report",
          active: pathname.includes("/report"),
          icon: Proportions,
          submenus: [],
        },
        {
          href: "marketplace",
          label: "Marketplaces",
          active: pathname.includes("/marketplace"),
          icon: Store,
          submenus: [],
        },
      ],
    },
  ];
}
